module.exports = "<select class=\"form-control\"\n        ng-options=\"obj.id as obj.name for obj in $ctrl.units\"\n        ng-model=\"$ctrl.ngModel\"\n        ng-disabled=\"$ctrl.mode == 'view'\">\n</select>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/blnd.units.picker.tpl.html
// module id = 745
// module chunks = 0